<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  height: 33vh;
  color: #fff;
  text-align: center;
  overflow: hidden;

  .bar {
    padding: 1.5vh;
    height: 100%;

    .main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <boxWrap :name="name" :min="true">
    <div class="table">
      <div class="bar">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from '../common/boxWrap';
import bar from 'components/dashboard/bar'
import echarts from "echarts";
export default {
  props: ['salesOrderAnalysis'],
  data() {
    return {
      name: '订单分析',
      dataX: [],
      dataY1: [],
      dataY2: [],
      nameX: ["本部订单", "外部订单"]
    }
  },
  components: {
    boxWrap,
    bar
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      this.myChart = echarts.init(document.querySelector(".bar .main"));
      this.myChart.clear()
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".bar .main"));
      this.myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '14%',
          top: '16%',
          containLabel: true
        },
        legend: {
          data: this.nameX,
          right: 10,
          top: 12,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 12,
          itemHeight: 10
          // itemGap: 35
        },
        xAxis: {
          type: 'category',
          data: this.dataX,
          axisLine: {
            lineStyle: {
              color: '#014B84'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#FFF',
              fontFamily: 'Microsoft YaHei'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#014B84'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#FFF',
              fontFamily: 'Microsoft YaHei'
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          }
        },
        series: [{
          name: '本部订单',
          type: 'bar',
          barWidth: '35%',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#E89F1E'
              }, {
                offset: 1,
                color: '#E89F1E'
              }])
            }
          },
          data: this.dataY1
        },
        {
          name: '外部订单',
          type: 'bar',
          barWidth: '35%',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#2492FF'
              }, {
                offset: 1,
                color: '#2492FF'
              }])

            }

          },
          data: this.dataY2
        }]
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    for (var i = 0; i < this.salesOrderAnalysis.length; i++) {
      this.dataX.push(this.salesOrderAnalysis[i].month)
      this.dataY1.push(this.salesOrderAnalysis[i].headquartersOrder)
      this.dataY2.push(this.salesOrderAnalysis[i].externalOrder)
    }

    var dataArr = [];
    var data = new Date();
    var year = data.getFullYear();
    data.setMonth(data.getMonth() + 1, 1)
    for (var k = 0; k < 6; k++) {
      data.setMonth(data.getMonth() - 1);
      var m = data.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      dataArr.push(data.getFullYear() + "-" + (m))
    }
    this.dataX = dataArr.reverse()
    var self = this;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      // 某些定时器操作
      self.getData()
    }, 3000);
  }
}

</script>

  


// WEBPACK FOOTER //
// index.vue?e7ef0e88